const minYears = 18;
const maxYears = 120;

const regexRU = /^[-а-яА-ЯёЁ ]+$/i;

export const getValidationTexts = (t) => {
  return {
    REQUIRED_MESSAGE: t('validation.REQUIRED_MESSAGE'),
    NOT_FOUND_MESSAGE: t('validation.NOT_FOUND_MESSAGE'),
    FORMAT_MESSAGE: t('validation.FORMAT_MESSAGE'),
    SPACE_MESSAGE: t('validation.SPACE_MESSAGE'),
    MIN_LENGTH: t('validation.MIN_LENGTH'),
    PASSWORD_REPEAT: t('validation.PASSWORD_REPEAT'),
    PHONE: t('validation.PHONE'),
    CYRILLIC_MESSAGE: t('validation.CYRILLIC_MESSAGE'),
    CORRECT_DATE: t('validation.CORRECT_DATE'),
    AGE_MESSAGE: t('validation.AGE_MESSAGE'),
    NAME_REGEXP: regexRU,
    REFERRAL_MESSAGE: t('validation.REFERRAL_MESSAGE'),
    REQUIRED_MESSAGE_ID: t('validation.REQUIRED_MESSAGE_ID'),
    FRIEND_ADDED: t('validation.FRIEND_ADDED'),
    IS_MY_UID: t('validation.IS_MY_UID'),
    FALLBACK_ERROR: t('validation.FALLBACK_ERROR'),
    ID_CHECK: t('validation.ID_CHECK'),
    ID_LENGTH_CHECK: t('validation.ID_LENGTH_CHECK'),
    INVALID_ID: t('validation.INVALID_ID'),
    INVALID_RANGE: t('validation.INVALID_RANGE'),
  };
};

export const validationTexts = {
  REQUIRED_MESSAGE: 'заполни поле',
  NOT_FOUND_MESSAGE: 'Соответствие не найдено',
  FORMAT_MESSAGE: 'неправильный формат',
  SPACE_MESSAGE: `Поле "Пароль" не может содержать пробел`,
  MIN_LENGTH: 'Минимальная длина 6 символов',
  PASSWORD_REPEAT: 'Введенные пароли не совпадают',
  PHONE: 'Номер телефона введён некорректно',
  CYRILLIC_MESSAGE: 'Введите имя на русском языке без пробелов',
  CORRECT_DATE: 'Введите корректную дату',
  AGE_MESSAGE: `Проверьте год рождения: ваш возраст может быть в дапазоне с ${minYears} до ${maxYears} лет`,
  NAME_REGEXP: regexRU,
  REFERRAL_MESSAGE: 'Вы ввели неверное слово',
  REQUIRED_MESSAGE_ID: 'Игрока с таким ID нет :(',
  FRIEND_ADDED: 'Игрок с таким ID уже добавлен!',
  IS_MY_UID: 'Нельзя добавить себя!',
  FALLBACK_ERROR: 'Произошла ошибка',
  ID_CHECK: 'Проверьте правильность id',
  ID_LENGTH_CHECK: 'В id 10 цифр',
};

/**
 * @param {string|{message}} name
 * @return {{required: *}}
 */
export function required(name, texts = validationTexts) {
  return {
    required: name?.message || texts.REQUIRED_MESSAGE,
  };
}

export function checkPhone(texts = validationTexts) {
  return {
    validate(val) {
      if (/[a-zA-Zа-яА-Я]+/.test(val) || val.match(/\d/g)?.join('').length !== 11) return texts.PHONE;
      return true;
    },
  };
}

export function email(name, texts = validationTexts) {
  return {
    ...required(name, texts),
    pattern: {
      value: /.+@.+\..+/,
      message: texts.FORMAT_MESSAGE,
    },
  };
}

export function cyrillic(texts = validationTexts) {
  return {
    pattern: {
      value: texts.NAME_REGEXP,
      message: texts.CYRILLIC_MESSAGE,
    },
  };
}

export function checkId(t) {
  const ID_LENGTH = 10;
  return {
    minLength: {
      value: ID_LENGTH,
      message: getValidationTexts(t).ID_LENGTH_CHECK,
    },
    maxLength: {
      value: ID_LENGTH,
      message: getValidationTexts(t).ID_LENGTH_CHECK,
    },
    validate(val) {
      if (!val) {
        return getValidationTexts(t).ID_CHECK;
      }

      if (val.length !== ID_LENGTH) return getValidationTexts(t).ID_LENGTH_CHECK;

      if (isNaN(Number(val))) return getValidationTexts(t).FORMAT_MESSAGE;

      return true;
    },
  };
}

export function checkName(t, from, to) {
  const message = getValidationTexts(t).INVALID_RANGE.replace('{{from}}', from).replace('{{to}}', to);
  return {
    required: message,
    minLength: {
      value: from ?? 1,
      message: message,
    },
    maxLength: {
      value: to ?? 10,
      message: message,
    },
  };
}

export function checkWord() {
  return {
    required: 'Диапазон от 1 до 30 символов',
    minLength: { value: 1 },
    maxLength: { value: 30 },
  };
}

export function username(texts = validationTexts) {
  return {
    ...required(null, texts),
    ...cyrillic(texts),
  };
}

export function password(getValue, texts = validationTexts) {
  return {
    validate(val) {
      if (!val) {
        return texts.REQUIRED_MESSAGE;
      }
      if (/\s/.test(val)) {
        return texts.SPACE_MESSAGE;
      }
      if (val.length < 6) {
        return texts.MIN_LENGTH;
      }
      if (getValue && getValue() !== val) {
        return texts.PASSWORD_REPEAT;
      }

      return true;
    },
  };
}

export function birthDate(texts = validationTexts) {
  return {
    /**
     *
     * @param val - "28.11.2023"
     * @returns {string|boolean}
     */
    validate(val) {
      if (!val) return texts.REQUIRED_MESSAGE;
      const [day, month, year] = val.split('.');
      let dateObj = new Date(`${year}/${month}/${day}`);

      function isValidDate(d) {
        return d instanceof Date && !isNaN(d);
      }

      if (!isValidDate(dateObj)) return texts.CORRECT_DATE;

      const minDate = new Date();
      minDate.setFullYear(minDate.getFullYear() - minYears);

      const maxDate = new Date();
      maxDate.setFullYear(maxDate.getFullYear() - maxYears);

      const isYounger = dateObj - minDate > 0;
      const isOlder = maxDate - dateObj > 0;

      if (!isYounger && !isOlder) return true;

      return texts.AGE_MESSAGE;
    },
  };
}
